module.exports = __webpack_public_path__ + "img/logo-dark.c52c3d6.svg";